import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Close } from "@air/next-icons";
import { Button } from "@air/primitive-button";
import { IconButton } from "@air/primitive-icon-button";
import classNames from "classnames";
import { memo, useRef } from "react";
import { CLEAR_SEARCH_TEXT_BTN, SEARCH_CLOSE } from "~/constants/testIDs";
import { preventDefaultMouseEvent } from "~/utils/ClickUtils";
export const SearchRightButtons = /*#__PURE__*/ memo((param)=>{
    let { isClearBtnVisible, onClearClick, onCloseClick, onFocusChange, hasValue } = param;
    const isClearFocused = useRef(false);
    const isCloseFocused = useRef(false);
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: classNames("items-center", isClearBtnVisible ? "pointer-events-all opacity-100" : "pointer-events-none opacity-0", hasValue ? "flex" : "hidden"),
                children: [
                    /*#__PURE__*/ _jsx(Button, {
                        "data-testid": CLEAR_SEARCH_TEXT_BTN,
                        onFocus: ()=>{
                            isClearFocused.current = true;
                            onFocusChange(true);
                        },
                        onBlur: ()=>{
                            isClearFocused.current = false;
                            onFocusChange(isCloseFocused.current);
                        },
                        appearance: "ghost",
                        color: "grey",
                        size: "small",
                        onClick: onClearClick,
                        // prevent default to not lose focus on search input
                        onMouseDown: preventDefaultMouseEvent,
                        children: "Clear"
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "mx-2 h-4 w-px bg-grey-7"
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(IconButton, {
                onFocus: ()=>{
                    isCloseFocused.current = true;
                    onFocusChange(true);
                },
                onBlur: ()=>{
                    isCloseFocused.current = false;
                    onFocusChange(isClearFocused.current);
                },
                "data-testid": SEARCH_CLOSE,
                icon: Close,
                appearance: "ghost",
                color: "grey",
                size: "small",
                onClick: onCloseClick,
                onMouseDown: preventDefaultMouseEvent,
                label: "Close search"
            })
        ]
    });
});
SearchRightButtons.displayName = "SearchRightButtons";
